import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import { toast } from "react-toastify";
import CorePushNotifications from "./app/core/components/CorePushNotifications/CorePushNotifications";

let connection;

export const startSignalRConnection = async (id, employment, studioId) => {
    connection = new HubConnectionBuilder()
        .withUrl(`${process.env.REACT_APP_API_URL.replace('/api', '')}notificationHub`, {
            withCredentials: false,
        })
        .withAutomaticReconnect()
        .configureLogging(LogLevel.Information)
        .build();

    try {
        await connection.start();

        connection.on(id, (notifica) => {
            toast(<CorePushNotifications notifica={notifica} />, {
                autoClose: 3000,
                position: "top-center",
            });
        });

        connection.on("NEWS_TYPE_" + employment + "_" + studioId, (notifica) => {
            toast(<CorePushNotifications notifica={notifica} />, {
                autoClose: 3000,
                position: "top-center",
            });

        });

        connection.on("NEWS_ALL_" + studioId, (notifica) => {
            toast(<CorePushNotifications notifica={notifica} />, {
                autoClose: 3000,
                position: "top-center",
            });

        });



    } catch (err) {
        console.error('Errore nella connessione:', err);
    }
};

export const stopSignalRConnection = async () => {
    if (connection) {
        await connection.stop();
    }
};